import React from 'react'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'

import { TtIconButton } from '@23/react'

import {
  useOverlayState,
  setChyron,
} from '../../../../../firebase/hooks/useOverlays'
import { TooltipComponent } from '../../../../components'
import type { JoinToSpeakRequest } from '../../../../join-to-speak'
import { useJoinToSpeakAsHost } from '../../../../join-to-speak'
import { WebinarPanelComponent } from '../index'
import { ChyronType } from '../../../../../firebase/model/chyron-model'

import { JoinToSpeakItem } from './join-to-speak-item'

import './join-to-speak-list.scss'

type JoinToSpeakListViewProps = {
  requests: JoinToSpeakRequest[]
  onAttendeePromotion: (attendeeId: string) => Promise<void>
  onAttendeeRejection: (attendeeId: string) => Promise<void>
}

const JoinToSpeakListView = ({
  requests,
  onAttendeePromotion,
  onAttendeeRejection,
}: JoinToSpeakListViewProps) => {
  const overlay = useOverlayState()
  const chyronIsShowing = overlay?.type === ChyronType.J2SIntroduction

  const label = chyronIsShowing
    ? intl.formatMessage({
        defaultMessage: 'Hide go on camera card',
      })
    : intl.formatMessage({
        defaultMessage: 'Show go on camera card',
      })

  return (
    <div className="section">
      <div className="section-title">
        <FormattedMessage defaultMessage="Asking to go on camera" />
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        {requests.length > 0 && ` (${requests.length})`}
        <TooltipComponent placement="topRight" title={label}>
          <TtIconButton
            label={label}
            name="eye"
            library="23"
            class="show-j2s-intro-chyron-button"
            onClick={() =>
              setChyron(
                chyronIsShowing ? null : { type: ChyronType.J2SIntroduction }
              )
            }
            data-active={chyronIsShowing}
          />
        </TooltipComponent>
      </div>
      <WebinarPanelComponent>
        {requests.length > 0 ? (
          <div className="requests">
            {requests.map((joinRequest) => (
              <JoinToSpeakItem
                key={joinRequest.attendeeId}
                attendeeId={joinRequest.attendeeId}
                attendeeName={joinRequest.attendeeName}
                attendeeFullName={joinRequest.attendeeFullName}
                attendeeEmail={joinRequest.attendeeEmail}
                question={joinRequest.question}
                handleAttendeePromotion={onAttendeePromotion}
                handleAttendeeRejection={onAttendeeRejection}
                previewImageUrl={joinRequest.previewImageUrl}
              />
            ))}
          </div>
        ) : (
          <div className="empty-j2s-requests">
            <FormattedMessage defaultMessage="Nobody has asked to go on camera" />
          </div>
        )}
      </WebinarPanelComponent>
    </div>
  )
}

const JoinToSpeakList = () => {
  const { requests, handleAttendeePromotion, handleAttendeeDenial } =
    useJoinToSpeakAsHost()

  return (
    <div className="join-request-list">
      <JoinToSpeakListView
        requests={requests}
        onAttendeePromotion={handleAttendeePromotion}
        onAttendeeRejection={handleAttendeeDenial}
      />
    </div>
  )
}

export { JoinToSpeakList }
